import { useState } from 'react';

import { CommentPreview } from '@gogame/components';

import CommentForm from './CommentForm';

export const DATA_CY = 'comment';

const Comment = ({
  mark,
  author = '',
  date = '',
  message = '',
  label,
  onComment,
  onDelete,
  withActions,
  autoFocus,
}) => {
  const [editing, setEditing] = useState(false);

  const handleComment = async (e, value) => {
    await onComment(e, value);
    setEditing(false);
  };
  const handleEdit = () => {
    setEditing(true);
  };
  const handleCancel = () => {
    setEditing(false);
  };

  if (editing) {
    return (
      <CommentForm
        label={label}
        initialValue={message}
        autoFocus={autoFocus}
        onChange={handleComment}
        onCancel={handleCancel}
      />
    );
  }

  return (
    <CommentPreview
      dataCy={DATA_CY}
      mark={mark}
      author={author}
      date={date}
      message={message}
      withActions={withActions}
      onEdit={handleEdit}
      onDelete={onDelete}
    />
  );
};
export default Comment;
